import '../styles/signinstyle.css'
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Divider } from '@material-ui/core';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CircularProgress from '@material-ui/core/CircularProgress';

export class ChangePasswordPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newpassword1: "",
            newpassword2: "",
            title: "Change Password",
            isFetching: false,
            isLoadingFinished: false,
        };
    }

    componentDidMount = async () => {
        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        await this.setState({ isLoadingFinished: true });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    changePassword = (event) => {
        event.preventDefault();

        this.setState({ isFetching: true });

        fetch(global.variables.API_USEROPERATIONS_PASSWORDCHANGE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        this.setState({ isFetching: false });
    };

    render() {

        const {
            newpassword1,
            newpassword2,
            isFetching,
            isLoadingFinished
        } = this.state


        if (!isLoadingFinished) {

            return (
                <CircularProgress />
            );

        } else {

            return (
                <Grid container direction="row" justify="center" alignItems="center" >
                    <Card style={{ maxHeight: 350 }}>
                        <CardHeader title="Change Password" className='romis-card-header' />
                        <CardContent>
                            <Typography variant="subtitle1" gutterBottom>Please enter your new password</Typography>
                            <Grid item>
                                <TextField
                                    label="Enter Your New Password:"
                                    placeholder="Password"
                                    margin="normal" fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={newpassword1}
                                    onChange={this.handleChange.bind(this)}
                                    name="newpassword1"
                                    type="password"
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="Re-Enter Your New Password:"
                                    placeholder="Password"
                                    margin="normal"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={newpassword2}
                                    onChange={this.handleChange.bind(this)}
                                    name="newpassword2"
                                    type="password"
                                />
                            </Grid>
                            <Grid item style={{ textAlign: "center" }}>
                                <Button variant="contained" color="primary"
                                    onClick={this.changePassword.bind(this)}
                                    disabled={isFetching ? true : false}>Change Password</Button>
                            </Grid>
                            <Grid>
                                <ToastContainer />
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            );
        }
    }
}





// WEBPACK FOOTER //
// ./src/pages/ChangePasswordPage.js